<app-header></app-header>
<div class="main-wrapper">
    <app-sidebar class="pull-left" (sidebarToggled)="sidebarToggled($event)"></app-sidebar>
    <div class="content-bg pb-1" [ngClass]="{'bg-shop': router.url.includes('shop-dashboard-configuration')}">
        <router-outlet></router-outlet>
    </div>
    <app-footer class="d-block text-sm text-right footer p-1"></app-footer>
</div>
